__turbopack_context__.v({
  "className": "caveat_830a29f5-module__n1xgCG__className",
});
